import React, {Component} from "react";
import {get} from "../../../helper/request";
import {error_manager} from "../../../helper/error_manager";
import {LoadingText} from "../components/components";
import {Stack, Tooltip, Typography} from "@mui/material";
import {bytesToHumanReadableSize, limitString} from "../../../utils/utils";

class DisksApp extends Component {

	getEmptyComponent =
		<Typography variant={"overline"} fontSize={20} color={"whitesmoke"}> No disks found </Typography>;

	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.fetchDisks().then();
	}

	fetchDisks = () => get(`/api/disks/info/`)
		.then(disks => disks.map(disk => this.getHumanReadableDiskInfo(disk)))
		.then(disks => this.setState({disks}))
		.catch(error => error_manager("Failed to fetch disks", error));

	getDiskField = (name, value) =>
		<Stack direction="row" justifyContent={"space-between"}>
			<Typography variant="body1" paddingX={1} color={"whitesmoke"}>{name}</Typography>
			<Tooltip title={(value || '').length > 15 ? value : null} placement="right">
				<Typography variant="body1" paddingX={1} color={"whitesmoke"}>
					{limitString(value || '', 18)}
				</Typography>
			</Tooltip>
		</Stack>;

	getHumanReadableDiskInfo = disk => ({
		id: disk.id,
		'Label (Editable)': disk.label,
		// Device: disk.device,
		'Mount Point': disk.mountPoint,
		'File System': disk.fsType,
		'Total Size': bytesToHumanReadableSize(disk.size),
		'Used Size': bytesToHumanReadableSize(disk.used),
		'Free Size': bytesToHumanReadableSize(disk.free),
		'Used %': `${disk.percent}%`,
	})

	getDiskComponent = disk =>
		<Stack direction="column" border={1} borderColor={"white"} padding={1}>
			{Object.entries(disk).map(([name, value]) => this.getDiskField(name, value))}
		</Stack>;

	render() {
		if (!this.state.disks)
			return <LoadingText/>
		if (this.state.disks.length === 0)
			return this.getEmptyComponent();

		return <Stack direction={"column"} spacing={2}>
			{this.state.disks.map(disk => this.getDiskComponent(disk))}
		</Stack>
	}

}

export default DisksApp;
